<template>
  <button @click="$emit('click')" :class="['black-button', icon]">
    <img :src="`/icons/${icon}.svg`" alt="" />
  </button>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "",
    },
  },
};
</script>
<style scoped>
.black-button {
  background: #1d1d1b;
  border-radius: 0.4444vh;
  border: none;
  width: 2.777vh;
  height: 2.777vh;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  margin-left: 1vh;
}
img {
  width: 1.6666666666666667vh;
  height: 1.6666666666666667vh;
}
.edit {
  background: #ffd2a8;
}
.save {
  background: #129b81;
}
.del {
  background: #e2223b;
}
.edit-transparent {
  border: 0.11111vh solid #1d1d1b;
  background: transparent;
}
.list {
  border: 0.11111vh solid #129b81;
  background: transparent;
}
.exclusive-star {
  border: 0.11111vh solid #464646;
  background: transparent;
}
.copy {
  border: 0.11111vh solid #416293;
  background: transparent;
}
.replace {
  border: 0.11111vh solid #129b81;
  background: transparent;
}
.delete-dish,.delete {
  border: 0.11111vh solid #e2223b;
  background: transparent;
}
.editor-move-black {
  border: 0.11111vh solid #1d1d1b;
  background: transparent;
}
.editor-duplicate-black {
  border: 0.11111vh solid #1d1d1b;
  background: transparent;
}
</style>
